import React, { useState, useEffect } from "react"
import { useCookies } from 'react-cookie';
import Sidebar from './SideBar';
import useAuthRedirect from "./Componentes/auth";
import Axios from 'axios';
import config from './Componentes/config';
import Swal from 'sweetalert2';
import { registrarLog } from './Componentes/logService';
import { validarArchivo, validarLiquidacion } from './Validations/TrabajadoresValidation';
import moment from 'moment';
import "moment/locale/es";
import { generarLiquidacionPDF } from "./Documentos/CreaLiquidacion.js";
import { formatRemuneracion, formatRutDV } from './Validations/TrabajadoresValidation';
import { getEmpresaByCodigo } from './Componentes/empresasConfig';

function CreacionLiquidaciones() {

    const cardImages = {
        DAFA: "/img/dafaLogo.png",
        FUGA: "/img/fugarLogo.png",
        INVE: "/img/idafaLogo.png",
        TRAN: "/img/extasisLogo.png",
        NIDI: "/img/nidiamLogo.png"
    };

    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const imageUrl = cardImages[cookies.selectedCard]
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);
    const [isAdministracionCollapsed, setIsAdministracionCollapsed] = useState(true);
    const [sueldoBase, setSueldoBase] = useState('');
    const [periodo, setPeriodo] = useState('');
    const [diasTrabajados, setDiasTrabajados] = useState('');
    const [diasAusentes, setDiasAusentes] = useState(0);
    const [horasExtra, setHorasExtra] = useState('');
    const [horasTrabajadasMes, setHorasTrabajadasMes] = useState('');
    const [anticipo, setAnticipo] = useState('');
    const [bonoMovilizacion, setBonoMovilizacion] = useState('');
    const [bonoCumplimiento, setBonoCumplimiento] = useState('');
    const [bonoUnico, setBonoUnico] = useState(0);
    const [descripcionBono, setDescripcionBono] = useState('');
    const [otrosDescuentos, setOtrosDescuentos] = useState('');
    const [valorDescuento, setValorDescuento] = useState(0);
    const [diasLicencia, setDiasLicencia] = useState(0);
    const [diasVacaciones, setDiasVacaciones] = useState(0);
    const [observaciones, setObservaciones] = useState('');
    const [horasDescontar, sethorasDescontar] = useState(0);
    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };
    const getEmpresaName = (card) => getEmpresaByCodigo(card).nombre;
    // Estados para el componente Trabajadores
    moment.locale("es");
    const [empresa, setEmpresa] = useState(getEmpresaName(cookies.selectedCard));
    const [trabajadores, setTrabajadores] = useState([]);
    const [idTrabajadorSeleccionado, setIdTrabajadorSeleccionado] = useState('');
    const [nombreTrabajadorSeleccionado, setNombreTrabajadorSeleccionado] = useState('');
    const [rutTrabajadorSeleccionado, setRutTrabajadorSeleccionado] = useState('');
    const [datosTrabajador, setDatosTrabajador] = useState(null); // AFP/Prevision/Cargo/TipoContrato (solo lectura)
    const [cargandoDatos, setCargandoDatos] = useState(false);
    const [feriados, setFeriados] = useState([]);                 // feriados legales del período
    const [feriadosDisponibles, setFeriadosDisponibles] = useState(true);
    const [detalleDias, setDetalleDias] = useState(null);         // desglose del mes comercial
    const [diasEfectivos, setDiasEfectivos] = useState(0);        // días que pagan movilización
    const idEmpresa = cookies.idEmpresa;
    const [seleccion, setSeleccion] = useState(false);
    const [editar, setEditar] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [files, setFiles] = useState([]);
    const [archivosDB, setArchivosDB] = useState([]);
    const [fechaCarga, setfechaCarga] = useState('');
    const [periodos, setPeriodos] = useState([]);
    const seleccionTrue = (ID) => {
        setSeleccion(true);
        console.log('ID:' + ID);
    }

    const getTrabajadores = () => {
        console.log("idEmpresa:", idEmpresa);  // Verifica que idEmpresa tiene el valor esperado
        console.log("intentando cargar trabajadores compensado");
        Axios.get(`${config.API_URL}/CargaTrabajadores?id=${idEmpresa}`)
            .then(res => {
                console.log(res.data); // Verifica la estructura de la respuesta
                if (Array.isArray(res.data)) {
                    setTrabajadores(res.data); // Asegúrate de que sea un array
                } else {
                    console.error('La respuesta no es un array:', res.data);
                    setTrabajadores([]); // Establece un array vacío si no es un array
                }
            })
            .catch(err => {
                console.error("Error al obtener los datos:", err);
            });
    }

    // Función auxiliar para formatear números con coma decimal
    const formatearNumeroConComa = (valor) => {
        if (!valor && valor !== 0) return '';
        return String(valor).replace('.', ',');
    };

    // Función para cargar datos automáticos del trabajador
    const cargarDatosTrabajador = async (idTrabajador, periodo) => {
        if (!idTrabajador || !periodo) {
            return;
        }

        setCargandoDatos(true);
        try {
            const response = await Axios.get(`${config.API_URL}/getDatosTrabajadorLiquidacion`, {
                params: { idTrabajador, periodo }
            });

            const datos = response.data;

            // Cargar TODOS los datos automáticamente (desde la asistencia sincronizada)
            setSueldoBase(formatearNumeroConComa(datos.sueldoBase));
            setDiasTrabajados(datos.diasTrabajados || '');
            setDiasAusentes(datos.diasAusentes || 0);
            setDiasVacaciones(datos.diasVacaciones || 0);
            setDiasLicencia(datos.diasLicencia || 0);
            setHorasExtra(formatearNumeroConComa(datos.horasExtra));
            setHorasTrabajadasMes(formatearNumeroConComa(datos.horasTrabajadasMes));
            sethorasDescontar(formatearNumeroConComa(datos.horasDescontar) || 0);
            setDatosTrabajador({
                afp: datos.afp || '-',
                prevision: datos.prevision || '-',
                cargo: datos.cargo || '-',
                tipoContrato: datos.tipoContrato || '-'
            });
            setFeriados(Array.isArray(datos.feriados) ? datos.feriados : []);
            setFeriadosDisponibles(datos.feriadosDisponibles !== false);
            setDetalleDias(datos.detalleDias || null);
            setDiasEfectivos(datos.diasEfectivos || 0);
        } catch (error) {
            console.error("Error al cargar datos del trabajador:", error);
        } finally {
            setCargandoDatos(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            idTrabajador: idTrabajadorSeleccionado,
            periodo: periodo,
            sueldoBase: sueldoBase,
            diasTrabajados: diasTrabajados,
            diasAusentes: diasAusentes,
            horasExtra: horasExtra,
            anticipo: anticipo,
            bonoMovilizacion: bonoMovilizacion,
            bonoCumplimiento: bonoCumplimiento,
            bonoUnico: bonoUnico,
            otrosDescuentos: otrosDescuentos,
            valorDescuento: valorDescuento,
            diasLicencia: diasLicencia,
            diasVacaciones: diasVacaciones,
            observaciones: observaciones,
            horasTrabajadasMes: horasTrabajadasMes,
            horasDescontadas: horasDescontar,
            DescripcionBono: descripcionBono
        };

        Axios.post(`${config.API_URL}/liquidacion`, data)
            .then(async res => {
                console.log(res.data);
                const datosRaw = res.data.datosLiquidacion;

                // Registrar en log la generación exitosa de liquidación
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'CreacionLiquidaciones',
                    Detalle: `Liquidación generada para trabajador ${nombreTrabajadorSeleccionado} (${formatRutDV(rutTrabajadorSeleccionado)}) - Período: ${periodo}`,
                    Estado: 'Éxito',
                });
                const datosPDF = {
                    logo: imageUrl,
                    rut: formatRutDV(rutTrabajadorSeleccionado),
                    nombre: nombreTrabajadorSeleccionado,
                    cargo: datosRaw.Cargo || "No asignado",
                    periodo: datosRaw.periodo,
                    salud: datosRaw.Prevision + " 7%", // podrías traerlo del backend si lo tienes
                    afpNombre: datosRaw.afpNombre.toUpperCase() + " " + datosRaw.afpTasa + "%",
                    uf: "-", // si tienes uf real, poner aquí
                    sueldoBase: formatRemuneracion(datosRaw.sueldoBase),
                    sueldoImponible: formatRemuneracion(datosRaw.baseImponible),
                    baseMensual: formatRemuneracion(datosRaw.baseMensual),
                    descuentoAFP: formatRemuneracion(datosRaw.descuentoAFP),
                    fechaIngreso: moment(datosRaw.fechaIngreso).format('DD/MM/YYYY'),
                    tipoContrato: datosRaw.tipoContrato,
                    DescripcionBono: datosRaw.DescripcionBono,
                    // Datos para formar arrays y mostrar en PDF
                    gratificacion: formatRemuneracion(datosRaw.gratificacion),
                    horasExtra: datosRaw.horasExtra,
                    totalHorasExtra: formatRemuneracion(datosRaw.totalHorasExtra),
                    valorHoraExtra: datosRaw.valorHoraExtra,
                    jornadaSemanal: datosRaw.jornadaSemanal,
                    descuentoFonasa: formatRemuneracion(datosRaw.fonasa),
                    seguroCesantia: formatRemuneracion(datosRaw.seguroCesantia),
                    impuestoUnico: formatRemuneracion(datosRaw.impuestoUnico),
                    totalDescuentos: formatRemuneracion(datosRaw.totalDescuentos),
                    bonoMovilizacion: formatRemuneracion(datosRaw.bono),
                    bonoCumplimiento: formatRemuneracion(datosRaw.bonoCumplimientoProporcional),
                    totalBonoUnico: formatRemuneracion(datosRaw.totalBonoUnico),
                    otrosDescuentos: datosRaw.otrosDescuentos,
                    valorDescuento: formatRemuneracion(datosRaw.valorDescuento),
                    totalHaberes: formatRemuneracion(datosRaw.totalHaberes),
                    anticipo: formatRemuneracion(datosRaw.anticipo),
                    descuentoPorHoras: formatRemuneracion(datosRaw.descuentoPorHoras),
                    horasDescontar: datosRaw.horasDescontadas,
                    diasTrabajados: datosRaw.diasTrabajados,
                    diasAusentes: datosRaw.diasAusentes,
                    diasLicencia: datosRaw.diasLicencia,
                    diasVacaciones: datosRaw.diasVacaciones,
                    observaciones: datosRaw.observaciones,

                    montoFinal: formatRemuneracion(res.data.montoFinal),
                    // montoFinalEnLetras: numeroALetras(res.data.montoFinal), // si tienes función para esto
                    BaseTributable: formatRemuneracion(datosRaw.BaseTributable),
                    // movimiento
                    atrasos: "00:00", // si tienes dato real, poner aquí
                    valorUF: datosRaw.valorUF.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    Prevision: datosRaw.Prevision,
                    Cargo: datosRaw.Cargo,
                    sumaDescuento: formatRemuneracion(datosRaw.sumaDescuento),
                    totalOtrosDctos: formatRemuneracion(datosRaw.totalOtrosDctos)
                };
                console.log("Datos en generarLiquidacionPDF:", imageUrl);
                generarLiquidacionPDF(datosPDF);
            })
            .catch(async err => {
                console.error(err);

                // Registrar error en log
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'CreacionLiquidaciones',
                    Detalle: `Error al generar liquidación para trabajador ${nombreTrabajadorSeleccionado || 'No seleccionado'} - ${err.message || 'Error desconocido'}`,
                    Estado: 'Error',
                });

                Swal.fire('Error', 'No se pudo calcular la liquidación', 'error');
            });
    };

    useEffect(() => {
        Axios.get(`${config.API_URL}/api/previred`)
            .then(res => {
                // Asumiendo que tu backend responde con un objeto que tiene "message"
            })
            .catch(error => {
                console.error('Error al llamar a /api/previred:', error);
            });
    }, []);

    useEffect(() => {
        getTrabajadores();
    }, []);

    useEffect(() => {
        Axios.get(`${config.API_URL}/getPeriodos`)
            .then(res => {
                if (Array.isArray(res.data)) {
                    setPeriodos(res.data);
                } else {
                    console.warn("Respuesta no es un array:", res.data);
                    setPeriodos([]);
                }
            })
            .catch(err => {
                console.error("Error al cargar periodos:", err);
                setPeriodos([]);
            });
    }, []);

    // useEffect para cargar datos automáticamente cuando cambie el trabajador o período
    useEffect(() => {
        if (idTrabajadorSeleccionado && periodo) {
            cargarDatosTrabajador(idTrabajadorSeleccionado, periodo);
        }
    }, [idTrabajadorSeleccionado, periodo]);

    // Estilos reutilizables (mismo lenguaje visual que Asistencia)
    const secCard = (color) => ({ background: '#fff', border: '1px solid #e3e6f0', borderLeft: `4px solid ${color}`, borderRadius: '8px', padding: '16px', marginBottom: '16px', boxShadow: '0 0.15rem 1.75rem rgba(58,59,69,.05)' });
    const secTitle = (color) => ({ fontSize: '12px', fontWeight: 700, color, textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: '14px' });
    const lbl = { fontSize: '13px', fontWeight: 600, color: '#5a5c69', marginBottom: '4px', display: 'block' };
    const chip = { background: '#f8f9fc', border: '1px solid #e3e6f0', borderRadius: '20px', padding: '4px 12px', fontSize: '12px', color: '#5a5c69' };

    return (
        <body id="page-top">
            <div id="wrapper">
                <Sidebar
                    imageUrl={imageUrl}
                    isComponentsCollapsed={isComponentsCollapsed}
                    toggleCollapse={toggleCollapse}
                    setIsComponentsCollapsed={setIsComponentsCollapsed}
                    isUtilitiesCollapsed={isUtilitiesCollapsed}
                    setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                    isInventario={isInventario}
                    setisIventatioCollapsed={setisIventatioCollapsed}
                    isPrevencion={isPrevencion}
                    setisPrevencionCollapsed={setisPrevencionCollapsed}
                    isLogistica={isLogistica}
                    setisLogisticaCollapsed={setisLogisticaCollapsed}
                    isContabilidadCollapsed={isContabilidadCollapsed}
                    setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                    isAdministracionCollapsed={isAdministracionCollapsed}
                    setIsAdministracionCollapsed={setIsAdministracionCollapsed}
                    cookies={cookies}
                />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card shadow mb-4">
                                        <div class="card-header py-3">
                                            <h6 class="m-0 font-weight-bold text-primary">Creacion de Liquidaciones de {empresa}</h6>
                                        </div>
                                        <div class="card-body">

                                            {/* Sección: Trabajador y período */}
                                            <div style={secCard('#4e73df')}>
                                                <div style={secTitle('#4e73df')}>👤 Trabajador y período</div>
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <label style={lbl}>Trabajador</label>
                                                        <select
                                                            className="form-select"
                                                            value={idTrabajadorSeleccionado}
                                                            onChange={(e) => {
                                                                const rut = e.target.options[e.target.selectedIndex].getAttribute('data-rut');
                                                                const nombre = e.target.options[e.target.selectedIndex].text;
                                                                const id = e.target.value;
                                                                setIdTrabajadorSeleccionado(id);
                                                                setNombreTrabajadorSeleccionado(nombre);
                                                                setRutTrabajadorSeleccionado(rut);
                                                                seleccionTrue(id);
                                                            }}
                                                        >
                                                            <option value="">Seleccione un trabajador:</option>
                                                            {(Array.isArray(trabajadores) ? trabajadores : []).map(trabajador => (
                                                                <option key={trabajador.ID_Trabajador} value={trabajador.ID_Trabajador} data-rut={trabajador.Rut}>
                                                                    {trabajador.NombreCompleto}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label style={lbl}>Período</label>
                                                        <select className="form-select" value={periodo} onChange={(e) => setPeriodo(e.target.value)}>
                                                            <option value="">Seleccione un periodo:</option>
                                                            {(Array.isArray(periodos) ? periodos : []).map((item, index) => {
                                                                const periodoRaw = item.Periodo;
                                                                const periodoFormateado = `${periodoRaw.slice(0, 2)}-${periodoRaw.slice(2)}`;
                                                                return (<option key={index} value={periodoRaw}>{periodoFormateado}</option>);
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                {datosTrabajador && (
                                                    <div className="d-flex gap-2 flex-wrap mt-3">
                                                        <span style={chip}><strong>AFP:</strong> {datosTrabajador.afp}</span>
                                                        <span style={chip}><strong>Previsión:</strong> {datosTrabajador.prevision}</span>
                                                        <span style={chip}><strong>Cargo:</strong> {datosTrabajador.cargo}</span>
                                                        <span style={chip}><strong>Contrato:</strong> {datosTrabajador.tipoContrato}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {idTrabajadorSeleccionado && periodo ? (
                                                <>
                                                    {/* Sección: Asistencia (auto) */}
                                                    <div style={secCard('#36b9cc')}>
                                                        <div style={secTitle('#36b9cc')}>🔄 Datos del período (cargados desde la asistencia)</div>
                                                        {cargandoDatos && <div style={{ color: '#858796', marginBottom: '10px', fontSize: '13px' }}>Cargando datos…</div>}
                                                        <div className="row g-3">
                                                            <div className="col-md-3"><label style={lbl}>Sueldo base</label><input type="text" className="form-control" value={sueldoBase} onChange={(e) => setSueldoBase(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Días trabajados</label><input type="text" className="form-control" value={diasTrabajados} onChange={(e) => setDiasTrabajados(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Días ausentes</label><input type="text" className="form-control" value={diasAusentes} onChange={(e) => setDiasAusentes(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Horas trabajadas</label><input type="text" className="form-control" value={horasTrabajadasMes} onChange={(e) => setHorasTrabajadasMes(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Horas extra 50%</label><input type="text" className="form-control" value={horasExtra} onChange={(e) => setHorasExtra(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Horas a descontar</label><input type="text" className="form-control" value={horasDescontar} onChange={(e) => sethorasDescontar(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Días licencia</label><input type="text" className="form-control" value={diasLicencia} onChange={(e) => setDiasLicencia(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Días vacaciones</label><input type="text" className="form-control" value={diasVacaciones} onChange={(e) => setDiasVacaciones(e.target.value)} /></div>
                                                        </div>

                                                        {/* Cómo se llegó a los días trabajados (mes comercial de 30) */}
                                                        {detalleDias && (
                                                            <div style={{ marginTop: '14px', padding: '10px 12px', background: '#f8f9fc', border: '1px solid #e3e6f0', borderRadius: '6px', fontSize: '12.5px', color: '#5a5c69' }}>
                                                                <strong>Días trabajados:</strong> {detalleDias.diasBaseMes} del mes comercial
                                                                {detalleDias.diasAusentes > 0 && <> − {detalleDias.diasAusentes} ausente{detalleDias.diasAusentes === 1 ? '' : 's'}</>}
                                                                {detalleDias.diasLicencia > 0 && <> − {detalleDias.diasLicencia} licencia</>}
                                                                {' = '}<strong>{diasTrabajados}</strong>
                                                                {detalleDias.diasVacaciones > 0 && (
                                                                    <>
                                                                        <br />
                                                                        <strong>Movilización:</strong> se paga sobre {diasEfectivos} días
                                                                        ({diasTrabajados} − {detalleDias.diasVacaciones} de vacaciones)
                                                                    </>
                                                                )}
                                                                <br />
                                                                <span style={{ color: '#858796' }}>
                                                                    Domingos, feriados y vacaciones son días remunerados: no descuentan.
                                                                    El período tiene {detalleDias.diasConMarca} día(s) con marca de trabajo.
                                                                </span>
                                                            </div>
                                                        )}

                                                        {/* Feriados legales del período (informativo) */}
                                                        <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px dashed #e3e6f0' }}>
                                                            <div style={{ fontSize: '12px', fontWeight: 700, color: '#6f42c1', marginBottom: '8px' }}>
                                                                🎉 Feriados legales del período
                                                            </div>
                                                            {!feriadosDisponibles ? (
                                                                <div style={{ fontSize: '13px', color: '#e74a3b' }}>
                                                                    ⚠️ No se pudo leer la tabla de feriados legales. Si hay una inasistencia cargada sobre un feriado, se va a descontar igual.
                                                                </div>
                                                            ) : feriados.length === 0 ? (
                                                                <div style={{ fontSize: '13px', color: '#858796' }}>Este período no tiene feriados registrados.</div>
                                                            ) : (
                                                                <div className="d-flex flex-column gap-1">
                                                                    {feriados.map(f => (
                                                                        <div key={f.fecha} style={{ fontSize: '13px', color: '#5a5c69' }}>
                                                                            <strong>{f.fecha.split('-').reverse().join('/')}</strong>
                                                                            {' · '}{f.nombre}
                                                                            {f.tipo === 'irrenunciable' && <span style={{ color: '#e74a3b', fontSize: '11px' }}> (irrenunciable)</span>}
                                                                            {' — '}
                                                                            <span style={{ color: f.trabajado ? '#1cc88a' : '#858796' }}>
                                                                                {f.trabajado ? '⏱️ ' : '• '}{f.detalle}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Sección: Haberes */}
                                                    <div style={secCard('#1cc88a')}>
                                                        <div style={secTitle('#1cc88a')}>➕ Haberes (bonos)</div>
                                                        <div className="row g-3">
                                                            <div className="col-md-3"><label style={lbl}>Bono movilización</label><input type="text" className="form-control" value={bonoMovilizacion} onChange={(e) => setBonoMovilizacion(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Bono cumplimiento</label><input type="text" className="form-control" value={bonoCumplimiento} onChange={(e) => setBonoCumplimiento(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Descripción bono</label><input type="text" className="form-control" value={descripcionBono} onChange={(e) => setDescripcionBono(e.target.value)} /></div>
                                                            <div className="col-md-3"><label style={lbl}>Monto bono único</label><input type="text" className="form-control" value={bonoUnico} onChange={(e) => setBonoUnico(e.target.value)} /></div>
                                                        </div>
                                                    </div>

                                                    {/* Sección: Descuentos */}
                                                    <div style={secCard('#e74a3b')}>
                                                        <div style={secTitle('#e74a3b')}>➖ Descuentos</div>
                                                        <div className="row g-3">
                                                            <div className="col-md-4"><label style={lbl}>Anticipo</label><input type="text" className="form-control" value={anticipo} onChange={(e) => setAnticipo(e.target.value)} /></div>
                                                            <div className="col-md-4"><label style={lbl}>Otros descuentos (detalle)</label><input type="text" className="form-control" value={otrosDescuentos} onChange={(e) => setOtrosDescuentos(e.target.value)} /></div>
                                                            <div className="col-md-4"><label style={lbl}>Monto descuento</label><input type="text" className="form-control" value={valorDescuento} onChange={(e) => setValorDescuento(e.target.value)} /></div>
                                                        </div>
                                                    </div>

                                                    {/* Observaciones + acción */}
                                                    <div className="row g-3 align-items-end">
                                                        <div className="col-md-8"><label style={lbl}>Observaciones</label><input type="text" className="form-control" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} /></div>
                                                        <div className="col-md-4">
                                                            <button className="btn btn-primary w-100" onClick={handleSubmit}>
                                                                <i className="fas fa-file-invoice-dollar"></i> Generar liquidación
                                                            </button>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <div style={{ textAlign: 'center', color: '#858796', padding: '20px' }}>
                                                    Selecciona un trabajador y un período para cargar los datos.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </body>
    )
}

export default CreacionLiquidaciones